controllers.controller('HostedPageController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$q', '$sce',
    'LocaleService', 'config', 'Validator', 'Storage', 'constants', 'ServerTimeService', 'Utils', 'UserService', 'API', 'ErrorService', '$cookies',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $q, $sce, LocaleService, config, Validator, Storage, Const,
              ServerTimeService, Utils, UserService, API, ErrorService, $cookies) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.showAmountSelect = true;
        $scope.depositValue = Storage.get('depositValue');
        $scope.validator = Validator.getPattern;
        $scope.methodName = $state.params.method.name || '';
        $scope.pspCurrencies = $state.params.method.pspCurrencies || [];
        $scope.pspCurrency = $scope.pspCurrencies.length > 0 ? $scope.pspCurrencies[0] : null;
        $scope.config = {
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum,
            visual: $scope.depositValue.visual,
            digits: 0,
            step: 50,
            listAmounts: [],
            pspCurrencies: $scope.pspCurrencies
        };

        $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');
        $scope.urlReady = false;

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.config.visual <= $scope.config.min ? $scope.config.min : $scope.config.visual);

        if (result.length > 0) $scope.config.listAmounts = result;

        $scope.amount = {
            value: $scope.config.visual,
            pspCurrency: $scope.pspCurrency
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'HostedPageController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function clearPayment(confirmResponse) {
            API.unsubscribe('depositConfirm');
            try {
                checkResponse(confirmResponse);
            } catch(e) {
                $ionicLoading.hide();
                if(e.code === 3022) {
                    $scope.paymentMethods.length > 1 ? $state.go('root.app.wallet') : $state.go( 'root.app.assets');
                    return;
                }
                $scope.modal.textTitle = LocaleService.translation.messages.depositFailed;
                $scope.modal.isError = true;
                $scope.modal.textContent = LocaleService.translation.messages.depositFailedText;
                $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
                $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                $scope.modal.state = true;
                return;
            }

            $ionicLoading.hide();
            $cookies.get('remarketing') && $cookies.remove('remarketing');
            $scope.modal.textTitle = LocaleService.translation.messages.depositSuccess;
            $scope.modal.isError = false;
            $scope.modal.actionText = LocaleService.translation.startTrading;
            $scope.modal.back = 'root.app.assets';

            $scope.modal.transactionId = confirmResponse.transactionId;
            $scope.modal.date = Date.now();
            $scope.modal.amount = Const.currencySymbols[confirmResponse.currency] + ' ' + confirmResponse.amount;
            $scope.modal.method = '';
            $scope.modal.state = true;
        }

        function doPayment() {
            var request = {
                amount: parseInt($scope.amount.value, 10),
                pspCurrency: $scope.amount.pspCurrency || undefined,
                pspName: Const.paymentMethodsBlueprint[$state.params.method.name] || $state.params.method.name,
                remarketing: $cookies.get('remarketing') || ''
            };

            $ionicLoading.show();

            return API.hostedPageDeposit(request)
                .then(checkResponse)
                .then(function (response) {
                    $scope.iframeUrl = $sce.trustAsResourceUrl(response.RedirectURL);
                    $scope.urlReady = true;
                    API.subscribe('depositConfirm', clearPayment);
                })
                .catch(function (error) {
                    return $scope.iframeLoadFail();
                })
        }

        $scope.getUrl = function () {
            return doPayment();
        };

        $scope.iframeLoad = function () {
            $ionicLoading.hide();
            $scope.iframeReady = true;
            $ionicLoading.hide();
        };

        $scope.iframeLoadFail = function () {
            $ionicLoading.hide();
            $scope.iframeReady = false;
            $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');

            $scope.modal.isError = true;
            $scope.modal.textTitle = LocaleService.translation.messages.general_error;
            $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
            $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
            $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
            $scope.modal.state = true;
        };


        function clear() {
            $scope.iframeReady = false;
            $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');
            $scope.user = null;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            if($state.params.method.hasOwnProperty("amountRequired") && !$state.params.method.amountRequired)  {
                $scope.showAmountSelect = false;
                $scope.amount.value = 1;
                doPayment();
            }
        });
        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);
    }
]);
